var translationJson = {
    "FOC": {
        "_COMMON_ACROSS_PAGES": {
            "AUDIO": {
                "CLOSE": "Cerrar",
                "DISABLE_SUBTITLES": "Ocultar subtítulos",
                "DISABLE_TRANSCRIPTS": "Ocultar transcripciones",
                "DRAG": "Arrastrar reproductor de audio",
                "ENABLE_SUBTITLES": "Mostrar subtítulos",
                "ENABLE_TRANSCRIPTS": "Mostrar transcripciones",
                "END_LOOP": "Terminar bucle",
                "ENTER_FULLSCREEN": "Pasar a pantalla máxima",
                "EXIT_FULLSCREEN": "Salir de pantalla máxima",
                "EXIT_LOOP": "Detener bucle",
                "FORWARD": "Adelantar 5 segundos",
                "PAUSE": "Pausar",
                "PLAY": "Reproducir",
                "REWIND": "Retroceder 5 segundos",
                "SETTINGS": "Pautas de configuración",
                "START_LOOP": "Iniciar bucle",
                "SLOW": "Lenta",
                "NORMAL": "Normal",
                "FAST": "Rápida",
                "SPEED": "Velocidad",
                "DURATION": "Duración",
                "CURRENT_TIME": "Tiempo actual",
                "SEEK": "Buscar",
                "VOLUME":"Volumen",
                "RESIZE": "Resize player"
            },
            "COOKIES_BANNER": {
                "ACCEPT": "Acepto cookies",
                "PRIVACY_POLICY": "Aviso de privacidad",
                "WEBSITE_USES_COOKIES": "Este sitio web utiliza cookies. Para más información, consulta la "
            },
            "FOOTER": {
                "ACCESSIBILITY": "Accesibilidad",
                "CAMBRDIGE_UNIVERSITY_PRESS": "Cambridge University Press & Assessment 2022",
                "EXPERIENCE_BETTER_LEARNING": "Experiencia de un Mejor Aprendizaje",
                "HELP": "Ayuda",
                "INSTITUTION_REQUEST": "Cambridge One para centros educativos",
                "PRIVACY_POLICY": "Aviso de privacidad",
                "TERMS_OF_USE": "Términos de uso",
                "GUIDED_TOUR": "Get started tour",
                "FAQ": "FAQs",
                "SCREEN_READER": {
                    "TABLE_OF_CONTENT": "Índice de contenido"
                }
            },
            "HEADER": {
                "CUP_LOGO": "Cambridge University Press Logo",
                "LOGOUT": "Cerrar la sesión",
                "MY_PROFILE": "Mi perfil",
                "SCREEN_READER": {
                    "CAMBRDIGE_LOGO": "Cambridge One Home"
                }
            },
            "HOTSPOTS": {
                "ACTIVITY_LO": "Actividad",
                "ANSWER_KEYS": "Respuestas",
                "AUDIO": "Audio",
                "DEFAULT": "Punto de acceso abierto",
                "EXTERNAL_LINK": "Abrir en una pestaña nueva",
                "GAME": "Juego",
                "GO_TO_PAGE": "Ir a página",
                "PREDEFINED_ZOOM": "Double tap to zoom",
                "VIDEO": "Video",
                "NOTE":"Nota",
                "PDF": "PDF"
            },
            "LO": {
                "CLOSE": "Cerrar",
                "DRAG": "Arrastrar esta casilla",
                "EXPAND": "Pasar a pantalla máxima",
                "MINIMIZE": "Salir de pantalla máxima",
                "MOBILE_MODAL_MESSAGE": "This content is designed for larger screens. Rotating your device may be easier to read"
            },
            "NOTES": {
                "ADD_NEW": "Añadir nueva",
                "ARE_YOU_SURE_CANCEL": "¿Estás seguro de querer cancelar?",
                "ARE_YOU_SURE_DELETE": "¿Estás seguro de querer borrar esta nota?",
                "BACK_TO_NOTES_PANEL": "Volver a notas",
                "CANT_BE_UNDONE": "Esta medida no puede revertirse",
                "CLOSE": "Cerrar",
                "CLOSE_NOTES": "Cerrar",
                "COLLAPSE" : "Achicar",
                "COLOR_OPTIONS": "Seleccionar color",
                "DELETE_NOTE": "Borrar",
                "EXPAND": "Agrandar",
                "FAILED_NOTES": "Error a cargar notas; vuelve a intentar",
                "GO_TO_PAGE": "Ir a página",
                "KEEP": "Conservar",
                "LOAD_NOTES": "Cargando notas",
                "SAVE_NOTE": "Guardar",
                "UNSAVED_LOST": "Se perderá todo lo editado que no hayas guardado",
                "YES_CANCEL": "Sí, cancelar",
                "YES_DELETE": "Sí, borrar",
                "NOTES_MESSAGE": "En este panel se pueden crear, editar y situar notas y enlaces en la página",
                "TYPE_HERE": "Escriba aquí...",
                "NOTES": "Mis notas y enlaces",
                "LOAD_FAIL": "Fallo al cargar",
                "BLUE": "azul",
                "GREEN": "verde",
                "ORANGE": "naranja",
                "RED": "rojo",
                "INPUT_COLOUR": "Haga clic para introducir un color.",
                "SELECT_COLOUR": "Seleccionar color",
                "PIN_NOTE_PAGE": "Sitúa la nota en la página",
                "CANCEL": "Cancelar",
                "DO_SAVE_AND_PIN": "¿Quieres guardar y situar en la página la nota aquí creada?",
                "YES_SAVE_AND_PIN": "Sí, guardar y situar la nota",
                "NO_TAKE_BACK": "No, llévame al paso anterior",
                "PIN_INFO": "Haz click en el sitio de la página en el que quieres que aparezca la nota",
                "NOTES_MENU": {
                    "TITLE": "Menú de notas",
                    "MOVE_PIN": "Desplazar el marcador",
                    "REMOVE_PIN": "Eliminar de la página el marcador",
                    "EDIT_NOTE": "Editar la nota",
                    "DELETE_NOTE": "Borrar la nota",
                },
                "SCREEN_READER": {
                    "CLOSE_ICON_ALT": "Cerrar mis notas"
                }
            },
            "SELECTION_BOX": {
                "CLOSE": "Cerrar"
            },
            "TIMER": {
                "CLEAR": "Despejar",
                "CLOSE": "Cerrar",
                "COUNT_DOWN": "Cuenta regresiva",
                "COUNT_UP": "Cuenta progresiva",
                "DRAG": "Arrastrar temporizador",
                "MUTE": "Silenciar audio",
                "PAUSE": "Pausar",
                "PLAY": "Reproducir",
                "RESET": "Restablecer",
                "UNMUTE": "Reactivar audio"
            },
            "TIP_MODAL": {
                "COMMON": {
                    "TITLE": "Cómo usar esta herramienta",
                    "DONT_SHOW_AGAIN": "No volver a mostrar",
                    "SCREEN_READER": {
                        "HELP_ICON_ALT": "Información"
                    }
                },
                "SELECTION_TOOLS": {
                    "TITLE": "Cómo usar esta herramienta",
                    "DESCRIPTION": "Hacer clic y arrastrar sobre la zona que se desea mostrar u ocultar",
                    "DONT_SHOW_AGAIN": "No volver a mostrar",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Cerrar"
                    }
                },
                "NOTES": {
                    "TITLE": "Cómo situar una nota en la página",
                    "DESCRIPTION": "Haz click en'Situar la nota en la página' y seguidamente haz click en el lugar en el que quieres que aparezca",
                    "DONT_SHOW_AGAIN": "No volver a mostrar",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Cerrar"
                    }
                },
                "NOTES_LINKS": {
                    "TITLE": "Cómo usar esta herramienta",
                    "DESCRIPTION": "Permite escribir y añadir notas y enlaces a recursos en la web, manteniéndolos organizados en un solo lugar",
                    "DONT_SHOW_AGAIN": "No volver a mostrar",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Cerrar"
                    }
                },
                "PDZ": {
                    "TITLE": "Hacer doble clic en una actividad para ampliarla",
                    "DESCRIPTION": "",
                    "DONT_SHOW_AGAIN": "No volver a mostrar",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Close"
                    }
                },
                "PDF": {
                    "TITLE": "Printable worksheets available in this unit",
                    "DESCRIPTION": "Click to open the printable worksheets in a new window. You will be taken to the new window automatically",
                    "DONT_SHOW_AGAIN": "Don't show again",
                    "SCREEN_READER": {
                        "CLOSE_BTN_ARIA_LABEL": "Close"
                    }
                }
            },
            "TOASTS": {
                "CHANGES_SAVED_AUTOMATICALLY": "Los cambios se guardarán automáticamente",
                "FAILED_DRAWINGS": "Error a cargar dibujos; vuelve a intentar",
                "FAILED_NOTES": "Error a cargar notas; vuelve a intentar",
                "LOAD_DRAWINGS": "Cargando dibujos",
                "SAVING_FAILED": "Error al guardar. Seguiremos intentando",
                "HIDEBOX": {
                    "TITLE": "You've reached the maximum number of {{maskLimit}} hide boxes",
                    "DESCRIPTION": "To add more hide boxes to this page, first remove some existing ones"
                }
            },
            "TOC": {
                "CLOSE_TOC": "Cerrar",
                "COLLAPSE": "Achicar",
                "EXPAND": "Agrandar",
                "JUMP_TO_PAGE": "Abrir",
                "LAST_VISITED_PAGE": "P.",
                "NEXT_PAGE": "Next Page",
                "PAGE_LABEL": "Page",
                "PAGE_NOT_EXIST": "La pagina no existe",
                "TOGGLE_EBOOK": "Cambiar material del curso",
                "ASSIGNMENT_MODAL": "Create assignment",
                "SCREEN_READER": {
                    "CLOSE_ICON_ALT": "Cerrar índice de contenido"
                },
                "RESOURCE_BANK": "Teacher's Resources"
            },
            "TOOLBAR": {
                "BAR": "Open Toolbar",
                "CLEAR": "Despejar",
                "CLOSE_HIGHLIGHTER_MENU": "Close Highlighter Options",
                "CLOSE_JUMP_TO_PAGE": "Cerrar opción “Ir a página”",
                "CLOSE_MAIN_MENU": "Close Main Options",
                "CLOSE_PAGE_VIEW": "Close Page View Options",
                "CLOSE_PEN_MENU": "Close Pen Options",
                "CLOSE_TOOLBAR": "Close Toolbar",
                "COLOR_MENU": "Color Menu",
                "CURSOR": "Cursor",
                "DOUBLE_PAGE": "Doble página",
                "DRAWING_TOOLS": "Herramientas de dibujo",
                "ERASER": "Eraser (Disabled)",
                "FIT_TO_SCREEN": "Ajustar a pantalla",
                "FIT_TO_WIDTH": "Ajustar a ancho",
                "FIT_TO_HEIGHT": "Ajustar a altura",
                "GO_TO_PAGE": "Ir a página",
                "HIGHLIGHTER": "Marcador para resaltar",
                "HIGHLIGHTER_COLOR": "Color",
                "HIGHLIGHTER_COLOR_OPTIONS": "Color de marcador",
                "HIGHLIGHTER_WIDTH": "Width",
                "HIGHLIGHTER_WIDTH_OPTIONS": "Ancho de marcador",
                "HOME": "Inicio",
                "INVERT": "Mover la barra de herramientas",
                "JUMP_PAGE": "Pasar a página",
                "MAIN": "Main Options",
                "MASK": "Hide selection",
                "NEXT_PAGE": "Página siguiente",
                "NOTES": "Notas",
                "OPEN_JUMP_TO_PAGE": "Abrir opción “Ir a página”",
                "PAGE_VIEW": "Page View Options",
                "PEN": "Herramientas de dibujo",
                "PEN_COLOR": "Color",
                "PEN_COLOR_OPTIONS": "Color de pluma",
                "PEN_WIDTH": "Width",
                "PEN_WIDTH_OPTIONS": "Ancho de pluma",
                "POSITION_TOOLBAR": "Position Toolbar",
                "PREVIOUS_PAGE": "Página anterior",
                "REDO": "Rehacer",
                "REMOVE_ALL": "Borrador",
                "SAVED": "Guardado",
                "SAVED_TOOLTIP": "Tus cambios se guardarán automáticamente cada 20 segundos",
                "SAVING": "Guardando",
                "SAVING_FAILED": "Error al guardar, vuelve a intentar",
                "SAVING_FAILED_TOOLTIP": "Tus cambios solo pudieron guardarse en este dispositivo",
                "SAVING_TOOLTIP": "Guardando; no dejes esta página",
                "SELECTION_TOOLS": "Show/Hide selection",
                "SINGLE_PAGE_VIEW": "Single page view",
                "SIZE_MENU": "Size Menu",
                "SPOTLIGHT": "Show selection",
                "STOPWATCH": "Stopwatch",
                "TIMER": "Temporizador",
                "TOC": " Contenido",
                "TOOLS": "Herramientas",
                "UNDO": "Deshacer",
                "ZOOM": "Opciones de zoom",
                "ZOOM_IN": "Acercar",
                "ZOOM_MENU": "Zoom Menu",
                "ZOOM_OUT": "Alejar",
                "ZOOM_SELECT": "Zoom to Selection"
            },
            "VIDEO": {
                "CLOSE": "Cerrar",
                "DECREASE_TRANSCRIPT_SIZE": "Reducir tamaño de caracteres",
                "DISABLE_SUBTITLES": "Ocultar subtítulos",
                "DISABLE_TRANSCRIPTS": "Ocultar transcripciones",
                "DRAG": "Arrastrar reproductor de audio",
                "ENABLE_SUBTITLES": "Mostrar subtítulos",
                "ENABLE_TRANSCRIPTS": "Mostrar transcripciones",
                "ENTER_FULLSCREEN": "Pasar a pantalla máxima",
                "EXIT_FULLSCREEN": "Salir de pantalla máxima",
                "FORWARD": "Adelantar 5 segundos",
                "INCREASE_TRANSCRIPT_SIZE": "Aumentar tamaño de caracteres",
                "PAUSE": "Pausar",
                "PLAY": "Reproducir",
                "REWIND": "Retroceder 5 segundos",
                "SETTINGS": "Pautas de configuración",
                "SLOW": "Lenta",
                "NORMAL": "Normal",
                "FAST": "Rápida",
                "SPEED": "Velocidad",
                "DURATION": "Duración",
                "CURRENT_TIME": "Tiempo actual",
                "SEEK": "Buscar",
                "VOLUME":"Volumen",
            }
        },
        "CREATE_USER_ANALYTICS": {
            "WELCOME_TEXT": "Welcome to your Cambridge One",
            "DESCRIPTION_TEXT": "We’re setting up the learning materials for you",
        },
        "DESKTOP": {
            "GUIDED_TOUR":{
                "WELCOME_HEADING": "Bienvenido a la Aplicación Desktop de Cambridge One",
                "WELCOME_DESC": "Ahora podrás tener acceso a eBooks y Presentation Plus fuera de línea",
                "DOWNLOAD_HEADING": "Descarga un eBook o Presentation Plus",
                "DOWNLOAD_DESC": "Así podrás tener acceso a él fuera de línea",
                "ONLINE_HEADING": "Podrás trabajar tanto en línea como fuera de línea",
                "ONLINE_DESC": "El trabajo que realices fuera de línea se sincronizará con tu cuenta de Cambridge One la próxima vez que estés en línea",
                "HELP_HEADING": "Más información sobre la aplicación",
                "HELP_DESC": "Vuelve a recorrer nuestra sección de Pasos iniciales o visita nuestra página de Preguntas frecuentes",
                "BACK": "Atrás",
                "NEXT": "Siguiente",
                "DONE": "Tarea cumplida"
            },
            "ASSIGNMENT_MODAL": {
                "DEFAULT_TITLE": "Select the class for which you want to create assignments",
                "ERROR_TITLE": "This material is not linked to any class",
                "NO_CLASS_MESSAGE": "Create a class in your Cambridge One account dashboard and add students and learning materials to it. You can then assign activities to your students",
                "NO_MATERIAL_MESSAGE": "Add learning materials to a class in your Cambridge One account dashboard. You can then assign activities to your students",
                "CREATE_CLASS": "Create a class",
                "ADD_MATERIALS": "Add materials",
                "TAKE_ME_TO_ASSIGNMENT": "Take me to assignments",
                "TAKE_ME_TO_DASHBOARD": "Take me to my dashboard",
                "CANCEL": "Cancel",
                "GO_BACK": "Go back",
                "CLOSE": "Close"
            },
            "CANCEL_DOWNLOAD_MODAL": {
                "DESC": "Esto significa que no podrás tener acceso a este material fuera de línea",
                "HEADING": "¿Estás seguro de querer cancelar esta descarga?",
                "KEEP": "Conservar",
                "REMOVE": "Sí, cancelar"
            },
            "DOWNLOAD_SPACE_ERROR_MODAL": {
                "DESC1": "Free up ",
                "DESC2": " on your computer to download ",
                "HEADING": "Not enough free space",
                "OK": "Ok",
            },
            "DOWNLOADING_ERROR_MODAL": {
                "DESC": "We were unable to download {{bookName}}, please try again. If the problem persists, click on Help to read our Cambridge One Desktop App FAQs",
                "HEADING": "Descarga no completada",
                "OK": "Ok",
            },
            "CLOSE_DIALOG": {
                "DOWNLOAD_IN_PROGRESS": "Download in progress",
                "HEADING": "Are you sure you want to exit the Desktop App?",
                "NO": "No, go back",
                "QUIT_MSG": "Some of your content is being downloaded and/or updated, and you will not have access to it offline until your content is up to date",
                "YES": "Yes, exit"
            },
            "DOWNLOAD_VALIDATION_MODAL": {
                "HEADING": "Fallo al descargar",
                "OK": "Aceptar",
                "VERSION_MISMATCH": "El contenido que está intentando descargar no está disponible actualmente. Vuelva a intentarlo en unos minutos."
            },
            "ERROR": {
                "BACK_TO_DASHBOARD": "Volver a tablero",
                "ERROR_SOMETHING_WRONG": "algo salió mal",
                "ERROR_UNEXPECTED_ERROR_DESCRIPTION_1": "Reinicia la aplicación",
                "OOPSIE": "Lamentablemente,"
            },
            "APP_ASSET_ERROR_MODAL": {
                "MODAL_TITLE": "This book is not complete",
                "MODAL_BODY_CONTENT_1": "Some of the content required to view this book has failed to download",
                "MODAL_BODY_CONTENT_2_OFFLINE": "Please delete this book and download it again to enable offline access",
				"MODAL_BODY_CONTENT_3_ONLINE": "The book uses downloaded assets which seem to be missing or corrupted. Please delete this downloaded book to view it.",
                "MODAL_BUTTON_1_OFFLINE": "Ok",
            },
            "LAUNCH": {
                "FORM": {
                    "ACCOUNT_REG": "¿Todavía no has abierto una cuenta?",
                    "FORGOT_PASSWORD": "¿Olvidaste tu contraseña?",
                    "INVALID_CREDENTIALS": "invalid loginID or password",
                    "LOGIN": "Inicia la sesión",
                    "LOGINID": "Correo electrónico",
                    "PASSWORD": "Contraseña",
                    "REQUIRED_FIELD": "Este campo es obligatorio",
                    "USERNAME_PLACEHOLDER": "Introducir dirección de email",
                    "PASSWORD_PLACEHOLDER": "Introducir contraseña"
                },
                "INSTRUCTION": {
                    "OFFLINE": "Si es la primera vez que abres sesión en esta aplicación, asegúrate de tener conexión a Internet",
                    "ONLINE": "Please enter your credential to login"
                },
                "OFFLINE": "No network Connection",
                "OFFLINE_BTN": "Enter Offline Mode",
                "OFFLINE_ERROR": {
                    "MESSAGE": "Para tener acceso fuera de línea a los materiales descargados, primero tendrás que iniciar sesión con conexión a Internet",
                    "TITLE": "En estos momentos estás fuera de línea"
                },
                "ONLINE": "You are currently online",
                "STATUS": {
                    "OFFLINE": "fuera de línea",
                    "ONLINE": "en línea"
                },
                "TITLE": "Cambridge One FOC App",
                "USER": {
                    "USERS": "Equipo de PC compartido",
                    "USERS_LIST_AVAILABLE_MSG": "Estás compartiendo este equipo con otras personas que iniciaron sesión previamente:",
                    "USERS_LIST_NOT_AVAILABLE_MSG": "Iniciada la sesión, tus datos aparecerán aquí"
                }
            },
            "LEARNER": {
                "DASHBOARD": {
                    "BOOK_INFO": "Información sobre el curso",
                    "BOOK_OPTIONS": "Opciones",
                    "BOOK_REMOVE": "Eliminar lo descargado",
                    "CANCEL": "Cancelar",
                    "DOWNLOAD": "Descargar",
                    "DOWNLOADED": "Descargado",
                    "FIRSTNAME": "Learner",
                    "HI": "Hola,",
                    "MY_PRIVATE_LEARNING": "Mi aprendizaje independiente",
                    "OFFLINE": "No network Connection",
                    "ONLINE": "You are currently online",
                    "PAUSE": "Pausar",
                    "RESUME": "Continuar",
                    "SCREEN_READER": {
                        "LAUNCH_PRODUCT": "Open materials"
                    },
                    "WORKBOOK": "Libro de actividades",
                    "COMING_SOON": "Se publicará en breve",
                    "BOOK_NOT_YET_PUBLISHED": "Este eBook no está disponible todavía",
                    "EXPIRED": "Caducato",
                    "ACTIVATE_TEXT": "Ahora podrás empezar a usar tus eBooks en la aplicación. Primero tendrás que activarlos en línea, o pregúntale a tu profesor a qué eBooks de la clase puedes",
                    "ACTIVATE_BTN": "Activar",
                    "CALCULATING_SIZE": "Calculating size...",
                    "DOWNLOAD_QUEUED": "Queued download..."
                }
            },
            "LOGOUT_MODAL": {
                "DESC_OFFLINE": "No podrás tener acceso fuera de línea a tus materiales descargados",
                "DESC_ONLINE": "No podrás tener acceso fuera de línea a tus materiales descargados. Solo recomendamos cerrar la sesión cuando se usa un dispositivo compartido",
                "GO_BACK": "No, volver atrás",
                "HEADING": "¿Estás seguro de querer cerrar la sesión?",
                "LOGOUT": "Sí, cerrar sesión",
                "DOWNLOAD": "Some of your content is being downloaded and/or updated, and you won’t be able to access your downloaded materials offline if you log out"
            },
            "REMOVE_DOWNLOAD_MODAL": {
                "DESC": "Este elemento será eliminado de lo descargado en tu dispositivo. Podrás seguir teniendo acceso a él en línea",
                "HEADING": "¿Estás seguro?",
                "KEEP": "Conservar",
                "REMOVE": "Sí, eliminar "
            },
            "APP_UPDATE_ERROR_MODAL": {
                "IMAGE_ALT_TEXT": "Cross",
                "MODAL_TITLE": "Download not successful",
                "CLOSE": "Close",
                "MODAL_MESSAGE_1": "Please relaunch the Cambridge One Desktop App to try again",
                "MODAL_MESSAGE_2": "There is not enough free space on your computer to complete the download. Please free 300 MB and relaunch the Cambridge One Desktop App",
                "EXIT_APP": "Close"
            },
            "TEACHER": {
                "DASHBOARD": {
                    "ALL_COURSES": "Todos los materiales del curso",
                    "CANCEL": "Cancelar",
                    "CLASSES": "Mis clases",
                    "CLEAR": "Despejar",
                    "DOWNLOAD": "Download",
                    "DOWNLOADED": "Descargado",
                    "FIRSTNAME": "Teacher",
                    "HI": "Hola,",
                    "INSTRUCTION": {
                        "OFFLINE": "Following is the list of all the products which have been downloaded for offline viewing. Please click on <strong>\"Launch\"</strong> button to launch the ebook component in offline mode.",
                        "OFFLINE_NO_PRODUCT": "Todavía no has descargado ningún material del curso. Cuando lo hagas, aparecerá aquí",
                        "ONLINE": "Following is the list of all the products having components which are powered to run in desktop mode. For now, this list shows only the products having ebook component. Please click on <strong>\"Launch\"</strong> button to launch the ebook in the eReader shell. Click on <strong>\"Download\"</strong> button to download the products for offline viewing. If you don't have internet connection, you can still see and launch the downloaded products."
                    },
                    "LAUNCH": "Launch eBook",
                    "LAUNCHOFFLINE": "Launch offline",
                    "LIBRARY": "Mi biblioteca",
                    "NO_SEARCH_RESULTS": "Esta búsqueda no tuvo resultados",
                    "OFFLINE": "No network Connection",
                    "ONLINE": "You are currently online",
                    "PAUSE": "Pausar",
                    "RESUME": "Continuar",
                    "SEARCH_PLACEHOLDER": "Buscar materiales del curso",
                    "COMING_SOON": "Se publicará en breve",
                    "BOOK_NOT_YET_PUBLISHED": "Este eBook no está disponible todavía",
                    "EXPIRED": "Caducato",
                    "ACTIVATE_TEXT": "Ahora podrás empezar a tener acceso a Presentation Plus o eBooks en la aplicación. Primero tendrás que activarlos en línea",
                    "ACTIVATE_BTN": "Activar",
                    "CLASS_ENDED": "Clase terminada",
                    "CALCULATING_SIZE": "Calculating size...",
                    "UP_TO_DATE": "Content up to date",
                    "DOWNLOAD_QUEUED": "Queued download..."
                },
                "PRODUCT_DETAIL": {
                    "AVAILABLE_OFFLINE": "Available offline",
                    "BACK_TO_COURSE": "Back to course",
                    "CANCEL": "Cancelar",
                    "DELETE_DOWNLOAD": "Borrar lo descargado",
                    "DOWNLOAD": "Descargar",
                    "DOWNLOADED": "Descargado",
                    "MATERIALS": "Materiales",
                    "NO_COMPONENT_MSG": "This title doesn't have any learning materials yet",
                    "NOT_DOWNLOADED": "Not downloaded",
                    "PAUSE": "Pausar ",
                    "PRODUCT_MENU": "Show product menu options",
                    "RESUME": "Continuar ",
                    "START_COURSE": "Start course",
                    "OFFLINE_MESSAGE": "Descargue esto cuando esté en línea para acceder más tarde fuera de línea.",
                    "OFFLINE_TOOLTIP": "Download this when you’re online to access it offline",
                    "COMING_SOON": "Se publicará en breve",
                    "BOOK_NOT_YET_PUBLISHED": "Este eBook no está disponible todavía",
                    "EXPIRED": "Caducato",
                    "EXPIRED_EBOOK": "eBook caduco",
                    "EXPIRES": "Caduca el",
                    "CALCULATING_SIZE": "Calculating size...",
                    "UP_TO_DATE": "Content up to date",
                    "DOWNLOAD_QUEUED": "Queued download..."
                }
            },
            "OFFLINE_ERROR_MODAL": {
                "ONLINE_MESSAGE": "We noticed your internet connection was restored. You will need to log in again to synchronise your changes",
                "OFFLINE_MESSAGE": "Internet connection lost. You now have access to the offline version. Any changes you make can be synchronised when your internet connection is restored and you log in again"
            },
            "AUTO_UPDATE": {
                "UPDATES": "Working on updates...",
                "RELAUNCH": "The app will close and relaunch automatically when updates are complete"
            }
        },
        "LO": {
            "TEACHER": {
                "ACTIVITYVIEW": {
                    "CHECK": "Check",
                    "NEXT": "Next",
                    "NEXT_ACTIVITY": "NEXT ACTIVITY",
                    "PREVIOUS": "Previous",
                    "REVIEW": "REVIEW",
                    "SHOW_ALL_ANSWERS": "Show answers"
                }
            },
            "RESULT_SCREEN": {
                "YOU_SCORED":"You scored",
                "MARKS_OUT_OF":"out of",
                "EXIT": "Exit activity",
                "REVIEW": "Review answers",
                "TRY_AGAIN": "Start again"
            }
        }
    },
    "HTML_META": {
        "FOC_EBOOK": {
            "DESCRIPTION": "Cambridge One is a mobile-friendly learning environment for English language learners and teachers.",
            "TITLE": "Ebook | Product"
        },
        "FOC_DESKTOP": {
            "DESCRIPTION": "Cambridge One is a mobile-friendly learning environment for English language learners and teachers.",
            "TITLE": "Cambridge One Desktop App | Cambridge University Press"
        },
        "MAIN": {
            "DESCRIPTION": "Cambridge One is a mobile-friendly learning environment for English language learners and teachers.",
            "TITLE": "Cambridge One | Cambridge University Press"
        }
    }
}
module.exports = translationJson;
